module.exports = __webpack_public_path__ + "static/media/UZ.67154c2b.svg";